import { connect } from 'react-redux'
import ModalActions from '../../../../../Redux/ModalRedux'
import DeviceUsageModal from './device-usage-modal'
import deviceUsageModalSelector from './device-usage-modal.selector'
import { translate } from 'react-translate'
import { pipe } from 'ramda'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  translate('CardsModals'),
  connect(
    deviceUsageModalSelector,
    mapDispatchToProps
  )
)(DeviceUsageModal)
